import { useContext, useState } from "react";
import "./Login.css";
import "../Welcome/WelcomePage.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../context/AppContext";
import Input from "@mui/joy/Input";
import { ThemeProvider } from "@emotion/react";
import theme from "../../themes/theme";
import { Button, CircularProgress } from "@mui/material";
import { ToastContainer } from "react-toastify";
import { toast } from "react-toastify";
import BASE_URL from "../../config/api";

export default function Login() {
  const navigation = useNavigate();
  const { setToken } = useContext(AppContext);
  const { setUserId } = useContext(AppContext);

  const [error] = useState(null);
  const [loading, setLoading] = useState(false);

  async function loginUser(data) {
    try {
      setLoading(true);
      const response = await axios.post(`${BASE_URL}/login`, data);
      const token = response.data.token;
      const id = response.data.userId;
      setToken(token);
      setUserId(id);

      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

      localStorage.setItem("token", token);
      setToken(token);
      localStorage.setItem("id", id);
      setUserId(id);
      const user = response.data.userRole;

      setUserId(id);

      user === 0 ? navigation(`/home/user/${id}`) : navigation(`/admin/${id}`);
    } catch (err) {
      localStorage.removeItem("token");
      setToken(null);
      toast.error("Invalid email or password!");
    } finally {
      setLoading(false);
    }
  }

  function handleClick(e) {
    e.preventDefault();
    loginUser({
      email,
      password,
    });
  }

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  return (
    <div className="login-wrapper">
      <form className="form-login">
        <p className="login-title">Login</p>
        <label className="label">Email address</label>
        <Input sx={{ width: "100%" }} variant="soft" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" name="email" required />
        <label className="label">Password</label>
        <Input sx={{ width: "100%" }} variant="soft" type="password" name="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} required />
        <div className="btn-container">
          <ThemeProvider theme={theme}>
            <Button variant="contained" id="login" onClick={handleClick}>
              {loading ? <CircularProgress size={20} color="inherit" /> : "Login to platform"}
            </Button>
            <Button variant="overline" onClick={() => navigation("/")}>
              Back
            </Button>
          </ThemeProvider>
        </div>
        <ToastContainer position="bottom-right" autoClose={3000} hideProgressBar />
        {error && <p style={{ color: "red" }}>{error}</p>}
      </form>
    </div>
  );
}
